export default __webpack_public_path__ + "static/media/DEN.02e0a2d0.svg";